<div fxLayout class="cipo--height--full cipo--overflow--hidden">
    <!-- Sidebar documents -->
    @if (data().showSidebar) {
        <div fxFlex="none" fxHide.lt-md class="cipo--height--full">
            <cipo-document-sidebar
                [allDisable]="(editing() && !isDraft()) || transitionStarted() || !selectedEntityInstanceId()"
                [selectedEntityInstanceId]="selectedEntityInstanceId()"
                (selectDocument)="onSidebarSelect($event)" />
        </div>
    }

    <div fxFlex="grow" class="cipo--overflow--auto cipo--height--full" [class.p-b-sm]="!selectedTabIndex()">
        @if (showTabs()) {
            <mat-tab-group
                mat-stretch-tabs="false"
                color="accent"
                [(selectedIndex)]="selectedTabIndex"
                class="cipo--height--full">
                <mat-tab label="Details">
                    <ng-container *ngTemplateOutlet="detailstTab"></ng-container>
                </mat-tab>
                <mat-tab label="Assignments">
                    <ng-template matTabContent>
                        <cipo-assignments
                            [entityInstanceId]="currentDocument().params.entityInstanceId"
                            [moduleId]="currentDocument().params.moduleId"
                            [hasUpdate]="info().canUpdate"
                            (assignmentsChanged)="assignmentChanged()" />
                    </ng-template>
                </mat-tab>
            </mat-tab-group>
        } @else {
            <ng-container *ngTemplateOutlet="detailstTab"></ng-container>
        }
    </div>
</div>

<input type="file" #fileInput style="display: none" (change)="onFileSelected($event)" [accept]="fileAccept()" />

<ng-template #detailstTab>
    <div
        class="p-x cipo-bg--primary-100 p-b cipo--min-height--58"
        fxLayout
        fxLayoutAlign="space-between center"
        fxHide.lt-md
        fxLayoutGap="12px">
        <cipo-document-header fxFlex [data]="headerData()" />
        @if (showWorkflowGroups()) {
            <button
                mat-button
                fxFlex="none"
                data-testid="document-details-workflow-group"
                [matMenuTriggerFor]="workflowGroupsMenu"
                [disabled]="!canChangeWorkflowGroup()">
                <span class="cipo-text--black-600">{{ "dm.details.workflow" | translate }}</span>
                {{ workflowGroupName() ?? ("dm.details.selectWorkflow" | translate) }}
                <mat-icon iconPositionEnd aria-hidden="true">arrow_drop_down</mat-icon>
            </button>
            <mat-menu #workflowGroupsMenu="matMenu">
                @for (group of workflowGroups(); track group.key) {
                    <button
                        mat-menu-item
                        (click)="setWorkflowGroup(group)"
                        [disabled]="group.key === workflowGroupId()">
                        {{ group.value }}
                    </button>
                }
            </mat-menu>
        }
    </div>
    <cipo-horizontal-splitter [leftPaneOptions]="leftPaneOptions()" [resizeStepper]="5" (onResize)="onResize($event)">
        <div class="p-x m-t" leftContent>
            @if (transitionStarted()) {
                <div fxLayoutAlign="end center">
                    @let title = "actions." + (leftPaneCollapsed() ? "expand" : "collapse") | translate;
                    <button
                        mat-icon-button
                        color="accent"
                        (click)="onResize(leftPaneCollapsed() ? 50 : 0.05)"
                        [matTooltip]="title"
                        [attr.aria-label]="title">
                        <mat-icon class="material-symbols-outlined" aria-hidden="true">
                            {{ leftPaneCollapsed() ? "right_panel_close" : "right_panel_open" }}
                        </mat-icon>
                    </button>
                </div>
            }
            @if (!leftPaneCollapsed()) {
                @if (info()?.approvalId) {
                    <div class="m-b p-b cipo--border-bottom--lite">
                        <cipo-awaiting-approval [entityInstanceInfo]="info()" (reload)="handleDocumentReviewed()" />
                    </div>
                }
                @if (loadFailed()) {
                    <cipo-load-error
                        message="dm.details.loadError"
                        testId="document-details-retry"
                        (retry)="retryLoad()" />
                } @else if (gridFields()) {
                    @defer (on idle) {
                        <cipo-dynamic-form
                            #dynamicForm
                            [form]="form"
                            [class.p-b]="isDraft()"
                            [fields]="gridFields().fields"
                            [contractId]="currentDocument().params.contractId"
                            [readonly]="!editing()"
                            (formValuesPrepared)="onUpdatesSubmit($event)" />
                    } @placeholder {
                        <div
                            role="status"
                            [attr.aria-busy]="true"
                            [attr.aria-label]="'a11y.documentDetails.loadingDocument' | translate">
                            <ngx-skeleton-loader
                                [theme]="{ width: '30%', height: '50px', margin: '10px' }"
                                count="3"></ngx-skeleton-loader>
                        </div>
                    }
                } @else {
                    <div
                        role="status"
                        [attr.aria-busy]="true"
                        [attr.aria-label]="'a11y.documentDetails.loadingDocument' | translate">
                        <ngx-skeleton-loader
                            [theme]="{ width: '30%', height: '50px', margin: '10px' }"
                            count="3"></ngx-skeleton-loader>
                    </div>
                }
            }
        </div>
        <!-- Transition form -->
        @if (transitionStarted()) {
            <div class="p-a" rightContent>
                <cipo-details-transition
                    #transitionFormComponent
                    [form]="transitionForm"
                    [compactMode]="compactTransitionForm()"
                    [entityInstanceId]="selectedEntityInstanceId()"
                    (transitionFormPrepared)="executeTransition($event)" />
            </div>
        }
    </cipo-horizontal-splitter>

    @if (info() && !isDraft()) {
        <div class="cipo--border-top--lite m-a p-t">
            <cipo-document-details-tabs [entityInstanceId]="selectedEntityInstanceId()" />
        </div>
    }
</ng-template>
